module.exports = __webpack_public_path__ + "media/mypage/images/fa/4-ae97eb69cdfec76b395f9a30b320db67.jpg";